import { UserChip } from '@/Ship/Helpers/fieldViews'

import { personName } from '../Helpers/diskFormat'

import type { DiskUserRef } from '../Contracts/DiskNode'

/**
 * Людина диска (автор, хто змінив): аватар і ім'я — Ship `UserChip`, той
 * самий, що в картках і реєстрах. Фото — `photoUrl` з бека, без нього —
 * ініціали; немає людини — прочерк.
 */
export const DiskPerson = ({ user, size }: { user: DiskUserRef | null; size?: number }) => {
    if (user === null || personName(user) === '—') return <span>—</span>

    return <UserChip user={user} {...(size !== undefined ? { size } : {})} />
}
